import { Accordion, Card, Grid, InputSelect, InputText, Typo } from "#/atoms";
import { DESKTOP_SPACING, FONT_SIZE, NATURAL } from "@/theme";
import { forwardRef, memo, useImperativeHandle } from "react";

import { AdditionalInfoCardProps } from "./AdditionalInfo.interface";
import { CardHandle } from "../Cards.interface";
import { HeadingIcon } from "#/molecules/HeadingIcon";

const AdditionalInfoCard = forwardRef<CardHandle, AdditionalInfoCardProps> (
 ({
  accordionState = 'open',
  poNumber,
  bedrooms,
  floorArea,
  isReadOnly,
  parking,
  virtualTourPartial
}, ref) => {

  useImperativeHandle(ref, () => ({
    validate: () => {
      bedrooms.validate();
      floorArea.validate();

      const isValid = bedrooms.error === null && floorArea.error === null;

      return { isValid: isValid, validationErrors: isValid ? [] : [ bedrooms.error ?? floorArea.error ?? '' ]};
    }
  }));

  return (
    <Card>
      <Accordion
        header={<HeadingIcon icon="additional" title="Additional Information" />}
        showArrow
        state={accordionState}
      >
        <Grid columnGap={DESKTOP_SPACING.XL} gridTemplateColumns="repeat(2, 40%)" margin="0">
        <InputText
            type="text"
            label="PO Number"
            value={poNumber.value}
            onChange={poNumber.onChange}
            readOnly={isReadOnly}
          />
          <InputText
            type="number"
            label="Number of bedrooms"
            value={bedrooms.value}
            onChange={bedrooms.onChange}
            readOnly={isReadOnly}
            errorMessage={bedrooms.error || ''}
            state={bedrooms.error ? 'error' : 'idle' }
            min={0}
            max={50}
            step={1}
          />
          <InputText
            type="number"
            max={100000}
            label="Sq ft. of property"
            value={floorArea.value}
            onChange={floorArea.onChange}
            readOnly={isReadOnly}
            errorMessage={floorArea.error || ''}
            state={floorArea.error ? 'error' : 'idle' }
            min={0}
            step={1}
          />
          <InputText
            type="text"
            label="Parking available"
            value={parking.value}
            onChange={parking.onChange}
            readOnly={isReadOnly}
          />
        </Grid>
        <Grid columnGap={DESKTOP_SPACING.XL} gridTemplateColumns="repeat(1, 100%)" margin="0">
          <InputSelect 
            type="checkbox"
            checked={virtualTourPartial.checked}
            label="360 Virtual Tours - Stick to package number of images"
            value={virtualTourPartial.value}
            onChangeValue={virtualTourPartial.onChange}    
            readOnly={isReadOnly}
            />
          <Typo fontColor={NATURAL.G} fontSize={FONT_SIZE.SM}>
          Please be aware that this might result in an incomplete 360 tour, with some parts potentially missing. However, you will not be charged for extra images.
          </Typo>
        </Grid>
      </Accordion>
    </Card>
  );
}
);

AdditionalInfoCard.displayName = 'AdditionalInfoCard';

export default memo(AdditionalInfoCard);